module.exports = __webpack_public_path__ + "static/media/ST5.2269d8d0.jpg";